<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      ハイリスク疑いの報告履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <table
      v-if="histories.length > 0"
      class="info-table"
    >
      <thead>
        <tr>
          <th>日時</th>
          <th>職種</th>
          <th>相談種類</th>
          <th>アラート種類</th>
          <th>相談員補足</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="history in histories"
          :key="history.id"
        >
          <td class="date-cell">
            {{ displayValue(history.reportedAt) }}
          </td>
          <td>{{ displayValue(history.occupation) }}</td>
          <td>{{ displayValue(history.consultationType) }}</td>
          <td class="alert-type-cell">
            <div
              v-if="history.reasons.length > 0"
              class="badge-list"
            >
              <v-tooltip
                v-for="reason in history.reasons"
                :key="reason"
                location="top"
                max-width="320"
              >
                <template #activator="{ props: tooltipProps }">
                  <span
                    v-bind="tooltipProps"
                    class="reason-badge"
                  >
                    {{ reason }}
                  </span>
                </template>
                <span>{{ reason }}</span>
              </v-tooltip>
            </div>
            <template v-else>
              -
            </template>
          </td>
          <td class="note-cell">
            {{ displayValue(history.supplementNote) }}
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #c8384f;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.section-title--empty {
  color: #888;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.info-table td.date-cell {
  color: #999;
}

.note-cell {
  max-width: 220px;
  white-space: normal;
  word-break: break-word;
}

.alert-type-cell {
  max-width: 140px;
}

.badge-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.reason-badge {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  background: #fdeaea;
  color: #c0392b;
  cursor: default;
}
</style>
